module.exports = __webpack_public_path__ + "static/media/person-running-with-shadow.2c5e0dbd.svg";